import ShopperNotifications from '../src/components/sections/ShopperNotifications';

export default ShopperNotifications;
